import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom'
import { Formik, Form } from 'formik';
import moment from 'moment';
import { extraInfoValidation } from '../utils/extrainfo';
import ObservationService from '../services/ObservationService';
import { useStore } from '../Store'
import useOnlineStatus from '../hooks/useOnlineStatus';
import { useConfirm } from './ConfirmDialog'
import { useToaster } from './Toaster'

// vaste onderdelen van het form
import ObservationDetails from './ObservationDetails'

import { isEqual } from '../utils/diff';

const ObservationContainer = () => {
  const location = useLocation()
  const history = useHistory()

  if (!location.state) history.push('/observations')

  const [observation, ] = useState(location.state?.observation)

  const { confirm } = useConfirm()
  const { showError } = useToaster()
  const isOnline = useOnlineStatus()

  const { settings, deleteUnsaved, updateUnsaved } = useStore()

  const formRef = React.useRef()

  // vul initiele waarden uit visit object
  const initialValues = {
    plot: -1,
    observation: {
      id: observation.id,
      description: observation.description,
      plot: '',
      dateStart: observation.timeStart.substr(0, 10),
      extraInfo: {},
      uploads: JSON.parse(JSON.stringify(observation.uploads)),
      location: JSON.parse(JSON.stringify(observation.location))
    }
  }
  settings.observationFields.forEach(field => {
    initialValues.observation.extraInfo[field.name] = (field.name in observation.extraInfo ? observation.extraInfo[field.name] : "")
  })

  const validate = (values) => {
    const errors = {};
    var name = 'observation.dateStart'
    if (!values.observation.dateStart) {
      errors[name] = 'verplicht';
    } else if (!moment(values.observation.dateStart).isValid()) {
      errors[name] = 'ongeldige datum';
    } else if (moment(values.observation.dateStart) > moment()) {
      errors[name] = 'toekomstige datum niet toegestaan'
    }

    settings.observationFields.forEach(field => {
      const error = extraInfoValidation(field, settings.lists[field.name], values.observation.extraInfo)
      if (error) errors[`observation.extraInfo.${field.name}`] = error
    });

    if (values.observation.location) {
      const location = values.observation.location
      if (location.buffer > 100) {
        errors['observation.location.buffer'] = 'locatie niet nauwkeurig genoeg. Zoom in.'
      }
    } else {
      errors['observation.location.pos'] = 'geef een locatie aan op de kaart'
    }

    return errors;
  }

  const mapValuesToObs = (values) => {
    const newObs = { ...observation }
    delete newObs.error
    newObs.id = values.observation.id
    newObs.description = values.observation.description
    newObs.timeStart = `${values.observation.dateStart}T00:00:00`
    settings.observationFields.forEach(field => {
      if (field.name in newObs.extraInfo || values.observation.extraInfo[field.name]) {
        newObs.extraInfo[field.name] = values.observation.extraInfo[field.name]
      }
    })
    newObs.uploads= values.observation.uploads
    newObs.location = values.observation.location
    return newObs
  }

  const isValid = async (formik) => {
    const errors = await formik.validateForm(formik.values)
    if (Object.keys(errors).length > 0) {
      showError('Een of meerdere velden hebben ongeldige waarde')
      return false
    }
    return true
  }

  //
  // main form event handlers
  //
  const handleSubmit = async () => {
    const formik = formRef.current
    const valid = await isValid(formik)
    if (!valid) return
    const newobs = mapValuesToObs(formik.values)
    if (isOnline) {
      try {
        await ObservationService.updateObservation(newobs)
        deleteUnsaved(newobs)
        history.push("/observations")
      }
      catch (error) {
        if (error.response && error.response.status === 401) history.push('/login')
        showError(error)
      }
    } else {
      updateUnsaved(newobs)
      history.push("/observations")
    }
  }

  const handleCancel = async () => {
    const formik = formRef.current
    if (!isEqual(formik.initialValues, formik.values)) {
      const confirmed = await confirm(`Wilt u de wijzigingen annuleren?`)
      if (!confirmed) return
    }
    history.push('/observations')
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={validate}
        innerRef={formRef}
        validateOnBlur={true}
        validateOnChange={true}
      >
        {(formik) => (
          <Form>
            <ObservationDetails
              single={true}
              readonly={false}
              formik={formik}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
            />
          </Form>)}
      </Formik>
    </>
  )
}

export default ObservationContainer